const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/orgs`,{params:n});return r};export{e as getAppOrgs};
//# sourceMappingURL=get-app-orgs.mjs.map